// Utils
import { isBuffer, keyIdentity } from './flatUtils';
/**
 * Following code is a copy from 'flat' library (v5.0.2): @see https://github.com/hughsk/flat.
 * The modifications performed by us is neglible, and is only confined to TS support and ESLint compliance.
 * Note: we haven't reviewed the code to avoid spending time rewriting it.
 *
 * @param target the object to be flatten
 * @param {FlattenOptions} opts extra options to perform flatten
 * @returns flatten object
 */
export var flatten = function (target, opts) {
    opts = opts || {};
    var delimiter = opts.delimiter || '.';
    var maxDepth = opts.maxDepth;
    var transformKey = opts.transformKey || keyIdentity;
    var output = {};
    var step = function (object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        // eslint-disable-next-line complexity
        Object.keys(object).forEach(function (key) {
            var value = object[key];
            var isArray = opts.safe && Array.isArray(value);
            var type = Object.prototype.toString.call(value);
            var isBufferObj = isBuffer(value);
            var isObject = type === '[object Object]' || type === '[object Array]';
            var newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);
            if (!isArray &&
                !isBufferObj &&
                isObject &&
                Object.keys(value).length &&
                (!opts.maxDepth || currentDepth < maxDepth)) {
                return step(value, newKey, currentDepth + 1);
            }
            output[newKey] = value;
            return undefined;
        });
    };
    step(target, undefined, undefined);
    return output;
};
//# sourceMappingURL=flatten.js.map